import { Model } from './model';

export class ChoicesModel extends Model {
  value: string;
  display_name: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/choices-model.ts